module.exports = __webpack_public_path__ + "img/send-inactive.be513018.png";